import { Box, Flex, HStack, Text } from '@chakra-ui/react';

interface IProgressDetail {
  status: number;
}
function ProgressDetail(props: IProgressDetail) {
  return (
    <Flex
      flexDirection={'column'}
      justifyContent={'center'}
      w={'full'}
      mt={'16px'}
      px={'10px'}
      py={'12px'}
      bg={'#eeeeee'}
      borderRadius={'base'}
      gap={'2px'}>
      <HStack spacing={'30px'}>
        <Text fontSize={'13px'} fontWeight="medium" color={'#191600'}>
          접수번호
        </Text>
        <Text fontSize={'13px'} fontWeight="medium" color={'#212121'}>
          {'CM240331-001'}
        </Text>
      </HStack>
      <HStack spacing={'30px'}>
        <Text fontSize={'13px'} fontWeight="medium" color={'#191600'}>
          접수일시
        </Text>
        <Text fontSize={'13px'} fontWeight="medium" color={'#212121'}>
          {'2024/04/06 (토) 12:25'}
        </Text>
      </HStack>
      {props.status === 1 && (
        <HStack spacing={'30px'}>
          <Text fontSize={'13px'} fontWeight="medium" color={'#191600'}>
            결제금액
          </Text>
          <HStack>
            <Text fontSize={'13px'} fontWeight="medium" color={'#128cfe'}>
              {'30,000'} 원
            </Text>
            <Text fontSize={'13px'} fontWeight="medium" color={'#212121'}>
              {'· ' + 'SMS' + ' 결제 완료'}
            </Text>
          </HStack>
        </HStack>
      )}
    </Flex>
  );
}
export default ProgressDetail;
